
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface BusinessPricingCardProps {
  title: string;
  description: string;
  features: string[];
  icon: React.ReactNode;
  priceInfo: {
    amount: string;
    unit: string;
  };
  serviceType: string;
}

const BusinessPricingCard: React.FC<BusinessPricingCardProps> = ({
  title,
  description,
  features,
  icon,
  priceInfo,
  serviceType,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all p-6 text-center border border-joerg-100">
      <div className="flex flex-col items-center mb-3">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10 text-primary mb-3">
          {icon}
        </div>
        <h3 className="text-lg font-bold text-joerg-800 mb-3 text-center">{title}</h3>
      </div>
      <p className="text-joerg-600 mb-6 text-left">{description}</p>
      
      <div className="space-y-3 mb-6">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start gap-2">
            <div className="w-5 h-5 rounded-full bg-joerg-100 flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-primary text-xs font-bold">✓</span>
            </div>
            <p className="text-joerg-600 text-sm text-left">{feature}</p>
          </div>
        ))}
      </div>
      
      <div className="mb-6 bg-joerg-50 p-4 rounded-lg text-center flex flex-col items-center justify-center">
        <p className="text-joerg-800 text-xl font-bold text-center">{priceInfo.amount}</p>
        <p className="text-xs text-joerg-600 mt-1 text-center">Angebote werden individuell erstellt</p>
      </div>
      
      <div className="text-center">
        <Link
          to={`/kontakt?tab=business&service=${serviceType}`}
          className="inline-flex items-center text-primary hover:text-primary-dark"
        >
          Individuelles Angebot anfragen
          <ArrowRight className="ml-2 h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};

export default BusinessPricingCard;
